import Column from "@components/column";

import StoreTypeForm from "./form";
import StoreTypeList from "./list";

const StoreType = () => {
  return (
    <Column>
      <StoreTypeForm />
      <StoreTypeList />
    </Column>
  );
};

export default StoreType;
